<template></template>
<script>
export default {
  inject: ['google', 'map'],
  props: {
    position: Object
  },
  data () {
    return { marker: null }
  },
  mounted () {
    // var DS = new this.google.maps.DirectionsService()
    // var DR = new this.google.maps.DirectionsRenderer()
    // DR.setMap(this.map)
    //
    // var request = {
    //   origin: this.position,
    //   destination: {'lat': 35.5279833, 'lng': 139.6989209},
    //   travelMode: this.google.maps.TravelMode.WALKING
    // }
    // DS.route(request, function (result, status) {
    //   DR.setDirections(result)
    // })

    const { Marker } = this.google.maps
    this.marker = new Marker({
      position: this.position,
      map: this.map,
      title: 'Child marker!'
    })
  }
}
</script>



// WEBPACK FOOTER //
// ChildMarker.vue?50397db3